import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Typography
} from '@mui/material';

const EncounterSection = ({
  title,
  children
}) => {
  if (!children) {
    return null;
  }

  return (
    <Box
      sx={{
        mb: 1.5,
        border: '1px solid #B9DCF3',
        borderRadius: '4px',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          minHeight: 30,
          px: 1.25,
          display: 'flex',
          alignItems: 'center',
          bgcolor: '#E3F2FB',
          borderBottom: '1px solid #B9DCF3'
        }}
      >
        <Typography
          sx={{
            color: '#424242',
            fontSize: 13,
            fontWeight: 500
          }}
        >
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          px: 1.25,
          py: 1.5
        }}
      >
        <Typography
          sx={{
            color: '#424242',
            fontSize: 12,
            lineHeight: 1.5,
            whiteSpace: 'pre-line'
          }}
        >
          {children}
        </Typography>
      </Box>
    </Box>
  );
};

EncounterSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node
};

EncounterSection.defaultProps = {
  children: null
};

export default EncounterSection;